// extracted by mini-css-extract-plugin
export default {"l_TrashIconBtn_innerContainer":"TrashIconBtn_l_TrashIconBtn_innerContainer__tueYb"};